import { useState } from "react";
import Modal from "./Modal";
import Impressum from "./Impressum";
import Datenschutz from "./Datenschutz";

export default function Footer() {
    const [activeModal, setActiveModal] = useState<
        "impressum" | "datenschutz" | null
    >(null);

    return (
        <>
            <footer className="py-12 border-t border-gray-200 bg-black">
                <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-sm text-white gap-6">
                    <p>© {new Date().getFullYear()} A&K Origins</p>

                    <div className="flex gap-6">
                        <button
                            onClick={() => setActiveModal("impressum")}
                            className="relative transition-colors after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-current after:transition-all hover:after:w-full"
                        >
                            Impressum
                        </button>
                        <button
                            onClick={() => setActiveModal("datenschutz")}
                            className="relative transition-colors after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-current after:transition-all hover:after:w-full">
                            Datenschutz
                        </button>
                    </div>
                </div>
            </footer>

            {/* MODAL */}
            {activeModal && (
                <Modal onClose={() => setActiveModal(null)}>
                    {activeModal === "impressum" && <Impressum />}
                    {activeModal === "datenschutz" && <Datenschutz />}
                </Modal>
            )}
        </>
    );
}